import { render, staticRenderFns } from "./ImgList.vue?vue&type=template&id=45a63f5a&scoped=true&"
import script from "./ImgList.vue?vue&type=script&lang=js&"
export * from "./ImgList.vue?vue&type=script&lang=js&"
import style0 from "./ImgList.vue?vue&type=style&index=0&id=45a63f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a63f5a",
  null
  
)

export default component.exports